export const stateKeys = {
  expandedRowKeys: 'expandedRowKeys',
};
